<template>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h2>Current Camera</h2>
                <code v-if="device">{{ device.label }}</code>
                <div class="border"  style="display:none">
                    <vue-web-cam
                        ref="webcam"
                        :device-id="deviceId"
                        width="100%"
                        @started="onStarted"
                        @stopped="onStopped"
                        @error="onError"
                        @cameras="onCameras"
                        @camera-change="onCameraChange"
                    />
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <select v-model="camera">
                            <option>-- Select Device --</option>
                            <option
                                v-for="device in devices"
                                :key="device.deviceId"
                                :value="device.deviceId"
                            >{{ device.label }}</option>
                        </select>
                    </div>
                    <div class="col-md-12">
                        <button type="button" class="btn btn-primary" @click="onCapture">Capture Photo</button>
                        <button type="button" class="btn btn-danger" @click="onStop">Stop Camera</button>
                        <button type="button" class="btn btn-success" @click="onStart">Start Camera</button>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <h2>Captured Image</h2>
                <figure class="figure">
                    <img :src="img" class="img-responsive" />
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { WebCam } from "vue-web-cam";
export default {
    name: "App",
    components: {
        "vue-web-cam": WebCam
    },
    data() {
        return {
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
            //
            timer: '',
        };
    },
    computed: {
        device: function() {
            return this.devices.find(n => n.deviceId === this.deviceId);
        }
    },

    watch: {
        camera: function(id) {
            this.deviceId = id;
        },
        devices: function() {
            // Once we have a list select the first one
            const [first, ...tail] = this.devices;
            if (first) {
                this.camera = first.deviceId;
                this.deviceId = first.deviceId;
            }
        }
    },
    mounted(){
        //this.timer = setInterval(this.captureFlow, 6000)
    },
    beforeDestroy () {
      console.log("destroy")
        clearInterval(this.timer)
    },
    methods: {
        captureFlow(){
            console.log("calling.....")
        },
         srcToFile(src, fileName, mimeType){
                return (fetch(src)
                    .then(function(res){return res.arrayBuffer();})
                    .then(function(buf){return new File([buf], fileName, {type:mimeType});})
                );
             },
        onCapture() {
            this.img = this.$refs.webcam.capture();
            //let f = new File(this.img.arrayBuffer(), "photo", {type:'image/png'});
            this.srcToFile(this.img, 'logo.png', 'image/png')
                .then(function(file){
                    console.log("file....."+file.size)
                    var fd = new FormData();
                    fd.append('doc', file);
                    axios.post( 'testCode/fileUpload',
                    fd,
                    {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                    }
                        ).then(function(){
                    console.log('SUCCESS!!');
                    })
                    .catch(function(){
                    console.log('FAILURE!!');
                    });
                    //return fetch('/upload.php', {method:'POST', body:fd});
                })
                .then(function(res){
                    //console.log(res)
                    //return res.text();
                })
                .then()
                .catch()
                ;
            return
            let formData = new FormData();
            console.log(this.f.size)
            reutrn
            formData.append("doc", this.img)
            //formData.append("fname", this.fname)
             //formData.append("doc1", this.filea)
            //formData.append("fname1", this.fnamea)
            console.log(formData)
            axios.post( 'testCode/fileUpload',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
                ).then(function(){
            console.log('SUCCESS!!');
            })
            .catch(function(){
            console.log('FAILURE!!');
            });
        },
        onStarted(stream) {
            console.log("On Started Event", stream);
            this.timer = setInterval(this.onCapture, 6000)
        },
        onStopped(stream) {
            console.log("On Stopped Event", stream);
            clearInterval(this.timer)
        },
        onStop() {
            this.$refs.webcam.stop();
        },
        onStart() {
            this.$refs.webcam.start();
        },
        onError(error) {
            console.log("On Error Event", error);
        },
        onCameras(cameras) {
            this.devices = cameras;
            console.log("On Cameras Event", cameras);
        },
        onCameraChange(deviceId) {
            this.deviceId = deviceId;
            this.camera = deviceId;
            console.log("On Camera Change Event", deviceId);
        }
    }
};
</script>